/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BidderStatsDto } from '../models/bidder-stats-dto';
import { getBidderStats } from '../fn/bidder-stats/get-bidder-stats';
import { GetBidderStats$Params } from '../fn/bidder-stats/get-bidder-stats';

@Injectable({ providedIn: 'root' })
export class GeneratedBidderStatsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBidderStats()` */
  static readonly GetBidderStatsPath = '/api/bidder-stats/{bidderIds}';

  /**
   * Gets statistics about one or more bidders.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBidderStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderStats$Response(params: GetBidderStats$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BidderStatsDto>>> {
    return getBidderStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets statistics about one or more bidders.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBidderStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderStats(params: GetBidderStats$Params, context?: HttpContext): Observable<Array<BidderStatsDto>> {
    return this.getBidderStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BidderStatsDto>>): Array<BidderStatsDto> => r.body)
    );
  }

}
